// src/pages/ComingSoonPage.js
import React from 'react';

const headingStyle = {
  fontSize: '1.5rem',
  fontWeight: '600',
  marginBottom: '1rem',
  transition: 'font-size 0.2s ease-in-out',
};

const textStyle = {
  color: '#57606a',
};

const ComingSoonPage = ({ title }) => {
  return (
    <div className="content-box" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
      <h1 
        style={headingStyle}
      >
        {title || '페이지'}
      </h1>
      
      <p style={textStyle}><br/>현재 페이지는 준비 중입니다.</p>
      <p style={textStyle}>곧 공개될 예정입니다.</p>
      
    </div>
  );
};

export default ComingSoonPage;